export enum AssistanceTypeEnum {
  CHILD = 'CHILD',
  ADULT = 'ADULT'
}
